import { defineStore } from "pinia";

interface UseQuickActionsState {
  isVisible: boolean;
}
const getDefaultState = (): UseQuickActionsState => ({
  isVisible: false,
});

const useQuickActionsStore = defineStore("quick-actions", {
  state: getDefaultState,
});

export default useQuickActionsStore;
